import cn from "classnames";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

// constants
import { Icon } from "@trussworks/react-uswds";
import { editSideNavItems } from "constants/side-nav";

// store
import { useResponsiveStore } from "store/useResponsiveStore";
import { useProfileEditStore } from "store/useProfileEditStore";
import useAuthStore from "store/useAuthStore";

// styles
import styles from "./EditSectionNavigation.module.scss";

export default function EditSectionNavigation() {
  const { extendedProfile } = useProfileEditStore((state) => ({
    extendedProfile: state.extendedProfile,
  }));

  const { closeMenu } = useResponsiveStore();
  const { user } = useAuthStore();

  const { hash, pathname } = useLocation();
  const navigate = useNavigate();

  const [activeItem, setActiveItem] = useState(editSideNavItems[0].path);

  const userRole = user?.role || "user";

  const showExclamationIcon = !extendedProfile?.participation_agreement;

  const filteredEditSideNavItems = editSideNavItems.filter((nav) =>
    nav.roles.includes(userRole)
  );

  useEffect(() => {
    if (hash) {
      setActiveItem(hash);
    }
  }, [hash]);

  const handleClick = (path: string) => {
    navigate(`${pathname}${path}`, { replace: true });
    closeMenu();
  };

  return (
    <ul className={styles["edit-section-navigation-root"]}>
      {filteredEditSideNavItems.map((item) => (
        <li
          key={item.path}
          className={cn(styles["item"], {
            [styles["active"]]: activeItem === item.path,
          })}
        >
          {item.path === "#participation" && showExclamationIcon && (
            <Icon.Error aria-label="explanation icon" />
          )}
          <button tabIndex={0} onClick={() => handleClick(item.path)}>
            {item.title}
          </button>
        </li>
      ))}
    </ul>
  );
}
